<template>
  <v-app primary>
    <v-layout column justify-center align-center>
      <v-flex>
        <br><br>
        <div class="text-xs-center">
          <img src="/static/ARCHIPRO7.png" alt="Vuetify.js" class="mb-5" />
        </div>
        <v-card>
          <v-card-text>
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-text-field label="E-mail" v-model="email" :rules="emailRules" required></v-text-field>

              <v-btn router to="/login">Retour</v-btn>
              <v-btn @click="submit" :disabled="!valid" color="blue darken-1">Envoyer </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        items: [],
        valid: true,
        password: '',
        email: '',
        emailRules: [
          (v) => !!v || 'Veuillez entrer obligatoirement votre e-mail',
          (v) => /^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
        ],
        beforeMount: function () {
          if(!this.roleAcces[this.$router.history.current.name]){
            this.$router.push({ name: 'Home'  })
          }
        }
      }
    },
    methods: {
      submit () {
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Password.vue